import { AgmMap } from '@agm/core';
import { AfterContentChecked, AfterContentInit, AfterViewChecked, AfterViewInit, Component, DoCheck, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChange, SimpleChanges, ViewChild } from '@angular/core';
import { AssigTripsService } from '../assigntrips-service/assigntrips-service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import * as moment from "moment-timezone";
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { sweetAlert, sweetAlertWithInput } from 'src/app/utils/swal';
import { FilterPipe } from 'src/app/pipe/list-filter-pipe/list-filter-pipe';
import * as _ from 'underscore';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { checkRole, hasOvertimeViolation, legTypeMap } from 'src/app/utils/utils.common';
import { AssistService } from 'src/app/service/assist-service/assist.service';
import { MenuService } from '../../shared/layout/menu-service/menu.service';
import { DriversService } from '../../drivers/drivers-service/drivers-service';

enum SORT_ORDER {
  ASC = 'ASC',
  DESC = 'DESC'
}

@Component({
  selector: 'app-driver-load-v3',
  templateUrl: './driver-load-v3.component.html',
  styleUrls: ['./driver-load-v3.component.css']
})
export class DriverLoadV3Component implements OnInit, OnDestroy {
  legTypeMap: any = legTypeMap;
  @Input() wrapper = '';
  @Output() _getLevelOfService = new EventEmitter<any>();
  @Output() _getSpaceTypes = new EventEmitter<any>();
  @Output() _getCorporates = new EventEmitter<any>();

  @Output() sendToBucket = new EventEmitter<string>();
  @Output() changeDriver = new EventEmitter<any>();
  @Output() _getServiceAreas = new EventEmitter<any>();
  @Output() _getDrivers = new EventEmitter<any>();
  @Output() _getStationManagerWiseDrivers = new EventEmitter<any>();
  @Output() _getAllTrips = new EventEmitter<any>();
  @Output() _getDriverTimelines = new EventEmitter<any>();
  @Output() _getStaff = new EventEmitter<any>();
  @Output() _processBucket = new EventEmitter<any>();
  @Output() _getNearbyDrivers = new EventEmitter<any>();
  @Output() _getViolationData = new EventEmitter<any>();
  @Output() _cancelTrip = new EventEmitter<any>();
  @Output() _driverBreak = new EventEmitter<any>();
  @Output() _makeItLive = new EventEmitter<any>();
  @Output() _getAssist = new EventEmitter<any>();
  @Output() _onUpdateTrip = new EventEmitter<any>();
  @Output() _setVersion = new EventEmitter<any>();

  @ViewChild("AgmMap", { static: false }) agmElement: AgmMap;
  @ViewChild('timer', { static: false }) timer;
  @Output() clear = new EventEmitter<any>();
  duration = 30 * 1000; // 10 seconds
  isTimerEnabled = false;
  isSorting = false;
  isAdvanceMode = false;
  cancelTripModalObj;

  agmMap;
  bounds;
  latitude: number;
  longitude: number;
  zoom: number = 12;
  drivers = [];
  filteredDrivers = [];
  selectedDriverId = '';
  selectedTripsDriver;
  timeZone;
  @Input()
  todayDate;
  search = '';
  allTrips;
  nonSuggestedTrips = [];
  nonSuggestedMainTrips = [];
  user;
  driverTrips = [];
  driverMainTrips = [];
  tripsPickupPoints = [];
  isDragging = false;
  waypoints = [];
  renderOptions = {
    suppressMarkers: true,
    // polylineOptions: {
    //   strokeColor: '#FF5733', // Set the desired color for the path
    //   strokeOpacity: 1,       // Set the opacity (0 to 1)
    //   strokeWeight: 4,       // Set the desired width of the path
    // },
  };
  isResizing = false;
  patients;
  selectedPatient = '';
  selectedLOS = '';
  showSlideFilter = false;
  selectedSpaceType = '';
  appointmentTypes;
  selectedAptType = '';
  selectedServiceArea = '';
  selectedCooperate = "";

  preCooperates = {};
  preLevelOfServices = {};
  preSpaceTypes = {};
  preServiceAreas = {};
  preDriver = {};
  driverServiceAreas = [];
  violations: any = {};

  preferedTrip;
  selectedEditTrip;
  partialEditModalObj;
  nearbyDrivers: any;
  selectedServiceAreas = [];

  selectedTripETA = null;
  geoCoder;
  corporateList = [];
  filteredCorporates = [];
  spaceTypeList = [];
  filteredSpaceTypes = [];
  serviceAreaList = [];
  filteredServiceAreas = [];
  levelOfServiceList = [];
  filteredLevelOfService = [];
  isGoogleMiles = 'false';
  selectedTimeLines;
  breakModalObj;
  columnsSortState = {
    preDist: '',
    newDist: '',
    distDiff: '',
    pickupDiff: '',
    dropoffDiff: ''
  }

  preStaffList = {};
  stationManagerList = [];
  selectedStationManager = [];
  isAllowDriversOnMap = false;
  selectedDropdownIndex: any;
  toggleActionButtons: boolean = false;
  isAllowRates = false;
  allowPostAdjustment = false;
  preAssistList;
  isRdispatcher = false;
  showSlideFilterLoad = false;
  showMap = false;
  version = '2'
  userRole;
  preDriversShiftOverrides;
  selectedDriverShiftOverrides;
  overrideShiftId = '';
  editTaxiRideModalObj: any;

  constructor(
    private socketService: SocketService,
    private assignTripService: AssigTripsService,
    private sharedDataService: SharedDataService,
    private assistService : AssistService,
    private menuService: MenuService,
    private driverService: DriversService
  ) { }

  ngOnInit() {
    window.addEventListener("keyup", this.initializeSpecialController);
    this._getViolationData.emit();
    this._getLevelOfService.emit();
    this._getSpaceTypes.emit();
    this._getCorporates.emit();
    this.getAssist();
    this.getUser();
    this.listenSocket();
  }


  initializeSpecialController = (e) => {
    if (
      e.altKey &&
      (e.key.toLowerCase() === "v" || e.key.toLowerCase() === "√")
    ) {
      this.isAdvanceMode = !this.isAdvanceMode;
    }
  };

  ngAfterViewInit() {
    // console.log('Driver Load: ngAfterViewInit()');
    if (this.agmElement) {
      this.agmElement.mapReady
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe((map) => {
          this.geoCoder = new google.maps.Geocoder;
          this.agmMap = map;
        });
    }
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = this.user.timeZone;
          this.todayDate = moment.tz(this.todayDate, this.timeZone).startOf('day').toISOString();

          if (this.user.sRoles && this.user.sRoles === "rdispatcher") {
            this.selectedStationManager = [this.user.sId];
            this.isRdispatcher = true;
          }

          if (this.user.hasOwnProperty('allowPostAdjustment')) {
            this.allowPostAdjustment = this.user.allowPostAdjustment;
          }

          if (this.user && this.user.roles) {
            if ((typeof this.user.roles) === 'string') {
              if(this.user.sRoles) {
                this.userRole = this.menuService.getUserRoleTitle(this.user.sRoles);
              } else {
                this.userRole = this.menuService.getUserRoleTitle(this.user.roles);
              }
            } else if ((typeof this.user.roles) === 'object') {
              this.userRole = this.menuService.getUserRoleTitle(this.user.roles[0]);
            }
          }

          // delay emit so that parent component gets ready
          setTimeout(() => {
            this._getStaff.emit();
          }, 500);
          this.isAllowRates = checkRole(this.user);
          this.getDriversShiftOverrides();
        }
      });
  }

  getAssist(){
    this.assistService.getAllAssists()
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(data => {
      if (data) {
        this.preAssistList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
      }
    });
  }

  getDriverList(apiResponse) {

    this.preDriver = apiResponse.reduce((obj, item) => (obj[item._id] = item, obj), {});

    if (this.isRdispatcher) {
      apiResponse = apiResponse.filter(item => item.stationManager === this.user.sId);
    }

    this.drivers = apiResponse;
    this.filteredDrivers = apiResponse;
    this.selectedDriverId = '';
    this.stationManagerWiseDrivers();
    this.getTripsEmit();
  }

  getTripsEmit() {
    let payload: any = {
      scheduleTime: this.todayDate
    };

    if (this.selectedDriverId) {
      payload.driver = this.selectedDriverId;
    }
    this._getAllTrips.emit(payload);
  }

  getViolationData(apiResponse) {
    this.violations = apiResponse;
  }

  onDateChange() {
    this.todayDate = moment.tz(this.todayDate, this.timeZone).startOf('day').toISOString();

    this.allTrips = [];
    this.nonSuggestedTrips = [];
    this.nonSuggestedMainTrips = [];
    this.driverTrips = [];
    this.tripsPickupPoints = [];
    this.driverMainTrips = [];
    this.waypoints = [];
    this.selectedTripsDriver = null;

    this.preferedTrip = null;
    this.preDriversShiftOverrides = null;
    this.selectedDriverShiftOverrides = null;
    this.overrideShiftId = '';
    this.getDriversShiftOverrides();
    // this.getTripsEmit();
    this.getDriverTimelinesEmit();

  }

  getAllTrips(apiResponse) {
    let payload: any = {
      scheduleTime: this.todayDate
    };

    if (this.selectedDriverId) {
      payload.driver = this.selectedDriverId;
    }

    this.allTrips = [];
    this.nonSuggestedTrips = [];
    this.nonSuggestedMainTrips = [];
    this.driverTrips = [];
    this.tripsPickupPoints = [];
    this.driverMainTrips = [];
    this.waypoints = [];
    this.selectedTripsDriver = null;

    if (apiResponse) {
      this.allTrips = apiResponse;
      this.filterTrips();
      if (this.isTimerEnabled) {
        this.timer.start();
      }
    }
  }

  filterTrips() {
    this.nonSuggestedTrips = [];
    this.driverTrips = [];
    let cooperates = [];
    let levelOfServices = [];
    let spaceTypes = [];
    let serviceAreas = [];
    this.appointmentTypes = [];
    this.patients = [];

    this.filteredLevelOfService = [];
    this.filteredSpaceTypes = [];
    this.filteredServiceAreas = [];
    this.filteredCorporates = [];

    this.allTrips.forEach(st => {
      if (st._id) {
        this.selectedTripsDriver = st._id;
        st.assigns.forEach(trip => {

          if (trip.status === 'cancelled' && !trip.job) {
            return;
          }

          this.driverMainTrips.push(trip)
        });
        // this.driverMainTrips.sort((a, b) => a.scheduleTime - b.scheduleTime)
      } else {
        this.nonSuggestedMainTrips = st.assigns;
        // this.nonSuggestedMainTrips.sort((a, b) => a.scheduleTime - b.scheduleTime)
      }
    });


    if (this.preferedTrip) {
      this.driverMainTrips.push(this.preferedTrip);
      // this.driverMainTrips.sort((a, b) => a.scheduleTime - b.scheduleTime)
    }

    // this.driverMainTrips.forEach(trip => {

    //   if (trip.cooperate) {
    //     this.cooperates.push(trip.cooperate);
    //   }

    //   if (trip.los) {
    //     this.levelOfServices.push(trip.los);
    //   }

    //   if (trip.spaceType) {
    //     this.spaceTypes.push(trip.spaceType);
    //   }

    //   if (trip.tripReason) {
    //     // remove the item having empty string
    //     if (trip.tripReason && trip.tripReason.length) {
    //       this.appointmentTypes.push(...trip.tripReason);
    //     }
    //   }
    //     // const zipCode = this.extractZipCode(trip.jobOriginAddress)
    //     if(trip.serviceArea){
    //       this.serviceAreas.push(trip.serviceArea);
    //     }
    //     if (trip.priorityClient) {
    //       this.patients.push({ displayName: trip.priorityClient.displayName });
    //     }
    // });

    this.nonSuggestedMainTrips.forEach(trip => {

      if (trip.cooperate) {
        cooperates.push(trip.cooperate);
      }

      if (trip.los) {
        levelOfServices.push(trip.los);
      }

      if (trip.spaceType) {
        spaceTypes.push(trip.spaceType);
      }

      if (trip.tripReason) {
        // remove the item having empty string
        if (trip.tripReason && trip.tripReason.length) {
          this.appointmentTypes.push(...trip.tripReason);
        }
      }
      // const zipCode = this.extractZipCode(trip.jobOriginAddress)
      if (trip.serviceArea) {
        serviceAreas.push(trip.serviceArea);
      }
      if (trip.priorityClient) {
        this.patients.push({ displayName: trip.priorityClient.displayName });
      }
    });

    if (this.selectedLOS)
      levelOfServices.push(this.selectedLOS)

    if (this.selectedSpaceType)
      spaceTypes.push(this.selectedSpaceType)

    if (this.selectedServiceArea)
      serviceAreas.push(this.selectedServiceArea)

    if (this.selectedAptType)
      this.appointmentTypes.push(this.selectedAptType)

    if (this.selectedPatient)
      this.patients.push(this.selectedPatient)


    cooperates = _.uniq(cooperates).sort();
    levelOfServices = _.uniq(levelOfServices).sort();
    spaceTypes = _.uniq(spaceTypes).sort();
    serviceAreas = _.uniq(serviceAreas).sort();
    this.appointmentTypes = [...new Set(this.appointmentTypes)].sort();
    this.patients = _.uniq(this.patients, 'displayName').sort();

    if (cooperates && cooperates.length) {
      this.filteredCorporates = this.corporateList.filter(c => cooperates.includes(c._id));
    }

    if (levelOfServices && levelOfServices.length) {
      this.filteredLevelOfService = this.levelOfServiceList.filter(l => levelOfServices.includes(l._id));
    }

    if (spaceTypes && spaceTypes.length) {
      this.filteredSpaceTypes = this.spaceTypeList.filter(s => spaceTypes.includes(s._id));
    }

    if (serviceAreas && serviceAreas.length) {
      this.filteredServiceAreas = this.serviceAreaList.filter(s => serviceAreas.includes(s._id));
    }

    this.filterTripsByModel();
  }

  toggleTimer() {
    this.isTimerEnabled = !this.isTimerEnabled;
    if (this.isTimerEnabled) {
      this.getTripsEmit();
    } else {
      this.timer.init();
    }
  }

  sortingMethod() {
    this.isSorting = !this.isSorting;
    console.log("Points check", this.tripsPickupPoints);

    if (this.tripsPickupPoints && this.tripsPickupPoints.length && this.tripsPickupPoints.length >2) {
      const first = this.tripsPickupPoints[0];
      const last = this.tripsPickupPoints[this.tripsPickupPoints.length - 1];
      const middle = this.tripsPickupPoints.slice(1, -1);

      if (this.isSorting) {
        middle.sort((a, b) => (a.priority || 0) - (b.priority || 0));
      } else {
        middle.sort((a, b) => <any>moment(a.scheduleTime) - <any>moment(b.scheduleTime));
      }

      this.tripsPickupPoints = [first, ...middle, last];
    };


  }

  onTimerComplete(): void {
    this.timer.init();
    this.getTripsEmit();
  }

  filterTripsByModel() {
    this.filterDriverMainTrips();
    this.filterNonSuggestedMainTrips();
  }

  sortPriorityWise(){
    this.isSorting = !this.isSorting;
    this.filterDriverMainTrips();
  }

  async filterDriverMainTrips() {
    this.driverTrips = this.driverMainTrips;
    this.driverTrips = new FilterPipe().transform(
      this.driverTrips,
      this.search
    );

    // this.driverTrips = new FilterByKeyPipe().transform(
    //   this.driverTrips,
    //   "assign.cooperate",
    //   this.selectedCooperate
    // );

    // if (this.selectedTripPurpose) {
    //   this.filterdataList = new FilterPipe().transform(
    //     this.filterdataList,
    //     this.selectedTripPurpose
    //   );
    // }

    // this.driverTrips = new FilterByKeyPipe().transform(
    //   this.driverTrips,
    //   "assign.los",
    //   this.selectedLOS
    // );
    // this.driverTrips = new FilterByKeyPipe().transform(
    //   this.driverTrips,
    //   "assign.spaceType",
    //   this.selectedSpaceType
    // );

    // if (this.selectedServiceArea) {
    //   this.driverTrips = new FilterByKeyPipe().transform(
    //     this.driverTrips,
    //     "assign.serviceArea",
    //     this.selectedServiceArea
    //   );
    // }

    // if (this.selectedAptType) {
    //   this.driverTrips = new FilterPipe().transform(
    //     this.driverTrips,
    //     this.selectedAptType
    //   );
    // }
    // if (this.selectedPatient) {
    //   this.driverTrips = new FilterByKeyPipe().transform(
    //     this.driverTrips,
    //     "assign.priorityClient.displayName",
    //     this.selectedPatient
    //   );
    // }

      if (this.isSorting) {
        this.driverTrips.sort((a, b) => (a.priority || 0) - (b.priority || 0));

      } else {
        this.driverTrips.sort((a, b) => <any>moment(a.scheduleTime) - <any>moment(b.scheduleTime));

      }
    // this.setupTripByPickup();
    const params = {
      todayDate: this.todayDate,
      user: this.user,
      selectedDriverId: this.selectedDriverId,
      drivers: this.drivers,
      violations: this.violations,
      preSpaceTypes: this.preSpaceTypes,
      selectedTimeLines: this.selectedTimeLines,
      driverTrips: this.driverTrips,
      selectedTripsDriver: this.selectedTripsDriver,
      isGoogleMiles: this.isGoogleMiles
    }
    if (this.selectedDriverShiftOverrides && this.selectedDriverShiftOverrides.length) {
      const singleOverrideShift = this.selectedDriverShiftOverrides
        .find(overrideShift => overrideShift._id === this.overrideShiftId);

      if (singleOverrideShift && !singleOverrideShift.isDefault) {
        params['singleOverrideShift'] = singleOverrideShift;
      }
    }
    this.tripsPickupPoints = await this.assignTripService.setupTripsByPickup(params);
  }

  filterNonSuggestedMainTrips() {
    this.nonSuggestedTrips = this.nonSuggestedMainTrips;
    this.nonSuggestedTrips = new FilterPipe().transform(
      this.nonSuggestedTrips,
      this.search
    );

    this.filterTripsMulti();

    // this.nonSuggestedTrips = new FilterByKeyPipe().transform(
    //   this.nonSuggestedTrips,
    //   "assign.cooperate",
    //   this.selectedCooperate
    // );

    // if (this.selectedTripPurpose) {
    //   this.filterdataList = new FilterPipe().transform(
    //     this.filterdataList,
    //     this.selectedTripPurpose
    //   );
    // }

    // this.nonSuggestedTrips = new FilterByKeyPipe().transform(
    //   this.nonSuggestedTrips,
    //   "assign.los",
    //   this.selectedLOS
    // );
    // this.nonSuggestedTrips = new FilterByKeyPipe().transform(
    //   this.nonSuggestedTrips,
    //   "assign.spaceType",
    //   this.selectedSpaceType
    // );

    // if (this.selectedServiceArea) {
    //   this.nonSuggestedTrips = new FilterByKeyPipe().transform(
    //     this.nonSuggestedTrips,
    //     "assign.serviceArea",
    //     this.selectedServiceArea
    //   );
    // }

    // if (this.selectedAptType) {
    //   this.nonSuggestedTrips = new FilterPipe().transform(
    //     this.nonSuggestedTrips,
    //     this.selectedAptType
    //   );
    // }
    // if (this.selectedPatient) {
    //   this.nonSuggestedTrips = new FilterByKeyPipe().transform(
    //     this.nonSuggestedTrips,
    //     "assign.priorityClient.displayName",
    //     this.selectedPatient
    //   );
    // }

    this.nonSuggestedTrips.sort((a, b) => <any>moment(a.scheduleTime) - <any>moment(b.scheduleTime));

  }

  filterTripsMulti() {
    this.nonSuggestedTrips = this.nonSuggestedMainTrips.filter(trip => {
      let isCorporateExist = true;
      let islosExist = true;
      let isSpaceTypeExist = true;
      let isServiceAreaExist = true;
      let isAptTypeExist = true;
      let isPatientExist = true;

      if (trip.priorityClient && trip.priorityClient.displayName && this.selectedPatient && this.selectedPatient.length) {
        isPatientExist = this.selectedPatient.includes(trip.priorityClient.displayName);
      }

      if (trip.spaceType && this.selectedSpaceType && this.selectedSpaceType.length) {
        isSpaceTypeExist = this.selectedSpaceType.includes(trip.spaceType);
      }

      if (trip.tripReason && this.selectedAptType && this.selectedAptType.length) {
        isAptTypeExist = trip.tripReason.some(item => this.selectedAptType.includes(item));
      }

      if (trip.cooperate && this.selectedCooperate && this.selectedCooperate.length) {
        isCorporateExist = this.selectedCooperate.includes(trip.cooperate);
      }

      if (trip.los && this.selectedLOS && this.selectedLOS.length) {
        islosExist = this.selectedLOS.includes(trip.los);
      }

      if (trip.serviceArea && this.selectedServiceArea && this.selectedServiceArea.length) {
        isServiceAreaExist = this.selectedServiceArea.includes(trip.serviceArea);
      }

      if (isPatientExist && isSpaceTypeExist && isAptTypeExist && isCorporateExist && islosExist && isServiceAreaExist) {
        return true;
      } else {
        return false;
      }
    });
  }

  ngOnDestroy(): void {
    window.removeEventListener("keyup", this.initializeSpecialController);
  }

  getUTCTime(travel) {
    return moment(travel).format("HH:mm:ss")
  }

  getFullUTCTime(travel, index, first) {

    let result = ''

    if (!first) {
      const travel1 = moment(this.tripsPickupPoints[index - 1].travel);
      const travel2 = moment(travel);

      const diff = moment.duration(travel1.diff(travel2)); // this returns a duration
      result = moment.utc(Math.abs(diff.asMilliseconds())).format("HH:mm:ss");

    }

    return { diff: result, date: moment(travel).format("MM/DD/YYYY") }
  }

  getTotalMiles() {
    let totalMiles = 0;
    for (let trip of this.driverTrips) {
      totalMiles = totalMiles + trip.milage;
    }
    return totalMiles.toFixed(2);
  }

  getDriverFromID() {
    const findDriver = this.drivers.find(driver => driver._id === this.selectedDriverId);
    return findDriver;
  }

  removeFromBucket(assign) {
    const isPublished = this.preDriver[this.selectedDriverId] && this.preDriver[this.selectedDriverId].tripStatus === 'published';
    if (isPublished) {
      sweetAlert("Alert", "This driver's route is already published. Modifications are not allowed.", "warning", "OK");
      return;
    }
    this.executeRemoveFromBucket(assign);
  }

  executeRemoveFromBucket(assign) {
    assign.status = 'unassigned';

    let indexTwo = this.driverMainTrips.findIndex(t => t._id === assign._id);
    if (indexTwo > -1) {
      this.driverMainTrips.splice(indexTwo, 1);
    }

    this.nonSuggestedMainTrips.push(assign);

    this.filterDriverMainTrips();
    this.filterNonSuggestedMainTrips();

    this._processBucket.emit({
      _id: assign._id,
      status: 'unassigned',
      jobStatus: 'pending'
    });
  }

  async sendToSpecificBucket(assign) {
    const isPublished = this.preDriver[this.selectedDriverId] && this.preDriver[this.selectedDriverId].tripStatus === 'published';
    if (isPublished) {
      sweetAlert("Alert", "This driver's route is already published. Modifications are not allowed.", "warning", "OK");
      return;
    }
    await this.executeSendToSpecificBucket(assign);
  }

  async executeSendToSpecificBucket(assign) {
    let findDriver = await this.drivers.find(d => d._id === this.selectedDriverId);
    
    let isOvertimeViolation = false;
    if (this.user.isManagerAuthorization && !['Restricted (RM,SM,ASM)', 'Dispatcher Manager', 'Full Access'].includes(this.userRole)) {
      isOvertimeViolation = hasOvertimeViolation(assign, findDriver.shifts, this.todayDate, this.timeZone);
    }

    let overTimeReason = '';
   if (isOvertimeViolation) {
     const result = await sweetAlertWithInput(
       "Alert",
       `${findDriver.displayName} has exceeded the allowed working hours. Are you sure you want to assign this trip?`,
       "warning",
       "Yes, Assign",
       "No",
       true,
       "Min. 10 characters.",
       isOvertimeViolation,
       this.user
     );
     if (result.value) {
      overTimeReason = result.value.note
     } else {
      return;
     }
   }

    assign.status = 'offered';
    // let findDriver = await this.drivers.find(d => d._id === this.selectedDriverId);
    this.driverMainTrips.push(assign);

    this.removePreferredTrip() ;

   let index = await this.nonSuggestedMainTrips.findIndex(t => t._id === assign._id);
    this.nonSuggestedMainTrips.splice(index, 1);

    this.filterDriverMainTrips();
    this.filterNonSuggestedMainTrips();

    this._processBucket.emit({
      _id: assign._id,
      status: 'offered',
      jobStatus: 'offered',
      driver: findDriver._id,
      overTimeReason: overTimeReason
    });
  }

  isTripAfterDriverShift(driver, trip): boolean {
    if (!driver || !driver.shift || !driver.shift.checkout || !trip || !trip.scheduleTime) {
      return false;
    }

    const tripTime = moment(trip.scheduleTime).tz(this.timeZone);
    const tripDate = tripTime.format('YYYY-MM-DD');
    const shiftEndTime = moment.tz(`${tripDate} ${driver.shift.checkout}`, 'YYYY-MM-DD HH:mm', this.timeZone);
    const twoHoursAfterShiftEnd = shiftEndTime.clone().add(2, 'hours');

    return tripTime.isAfter(twoHoursAfterShiftEnd);
  }

  processBucket(apiResponse) {
    this.filterDriverMainTrips();
    this.filterNonSuggestedMainTrips();
  }

  removePreferredTrip() {
    if (this.preferedTrip) {
      const idx = this.driverMainTrips.findIndex(trip => trip._id === this.preferedTrip._id);
      if (idx >= 0) {
        this.driverMainTrips.splice(idx, 1);
      }
    }
    this.preferedTrip = null;
  }

  cancelBreak(assign) {
    sweetAlert(
      "Alert",
      "Are you sure you want to cancel this break?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        const payload = {
          _id: assign._id,
          status: 'cancelled',
          jobStatus: 'cancelled',
          changeReason: ''
        }
        this._cancelTrip.emit(payload);
      }
    });
  }

  cancelTrip(payload, apiResponse) {
    let findTripIndex = this.driverMainTrips.findIndex(t => t._id === payload._id);
    if (findTripIndex > -1) {
      this.driverMainTrips.splice(findTripIndex, 1);
    }
    this.filterDriverMainTrips();
    this.filterNonSuggestedMainTrips();
  }




  toggleSelection(item: any): void {
    if (item.polyline) {
      item.polyline = false
    } else {
      item.polyline = true
    }
    this.waypoints = [];
    for (let point of this.tripsPickupPoints) {
      if (point.polyline) {
        this.waypoints.push(
          { stopover: false, location: { lat: point.isPickup ? point.jobOriginLatitude : point.jobDestinationLatitude, lng: point.isPickup ? point.jobOriginLongitude : point.jobDestinationLongitude } }
        )
      }
    }
  }

  onMouseDown(item: any) {
    this.isDragging = true;
    this.toggleSelection(item);
  }

  onMouseUp() {
    this.isDragging = false;
  }

  onMouseOver(item: any) {
    if (this.isDragging) {
      this.toggleSelection(item);
    }
  }


  showFilter() {
    this.showSlideFilter = !this.showSlideFilter;
  }

  closeFilter() {
    this.showSlideFilter = false;
  }

  showFilterLoad() {
    this.showSlideFilterLoad = !this.showSlideFilterLoad;
  }

  closeFilterLoad() {
    this.showSlideFilterLoad = false;
  }

  getCorporate(apiResponse) {
    this.corporateList = apiResponse;
    this.preCooperates = apiResponse.reduce((obj, item) => (obj[item._id] = item, obj), {});
  }

  getLevelOfService(apiResponse) {
    this.levelOfServiceList = apiResponse;
    this.preLevelOfServices = apiResponse.reduce((obj, item) => (obj[item._id] = item, obj), {});
  }

  getSpaceTypes(apiResponse) {
    this.spaceTypeList = apiResponse;
    this.preSpaceTypes = apiResponse.reduce((obj, item) => (obj[item._id] = item, obj), {});
  }

  getStaffList(apiResponse) {

    if (this.isRdispatcher) {
      this.stationManagerList = apiResponse.filter(staff => staff._id === this.user.sId );
    } else {
      this.stationManagerList = apiResponse.filter(staff => ["mdispatcher","mcallcenter","rdispatcher"].includes(staff.roles));
    }

    this.preStaffList = apiResponse.reduce((obj, item) => (obj[item._id] = item, obj), {});
    this._getServiceAreas.emit();
  }

  getServiceAreas(apiResponse) {
    this.driverServiceAreas = apiResponse;
    this.serviceAreaList = apiResponse;
    this.preServiceAreas = apiResponse.reduce((obj, item) => (obj[item._id] = item, obj), {});
    this.getDriverEmit();
  }

  getDriverEmit() {
    let endPoint = '';

    if (this.selectedServiceAreas && this.selectedServiceAreas.length) {
      endPoint = '?serviceAreas=' + this.selectedServiceAreas.toString();
    }

    const data = {
      endPoint: endPoint,
      userId: this.user._id
    }
    this._getDrivers.emit(data);
  }

  roundTwoDigit(value: any) {
    let numberValues;
    if (typeof value !== 'number') {
      numberValues = parseFloat(value).toFixed(2);
    } else {
      numberValues = value.toFixed(2);
    }

    return numberValues;
  }

  getMarkeBall(assign, isPickup) {

    let icon = isPickup ? 'assets/images/map/origin_circle.png' : 'assets/images/map/destination_circle.png'
    if (assign.jobStatus === 'finished' || assign.jobStatus === 'cancelled') {
      icon = 'assets/images/map/finished_circle.png';
    }

    return icon;
  }

  horizontalResizing(event: MouseEvent) {
    this.isResizing = true;
    const sidebarLeft = document.getElementById('horizontal-sidebar-left');
    const sidebarRight = document.getElementById('horizontal-sidebar-right');

    if (sidebarLeft && sidebarRight) {
      const initialWidthL = sidebarLeft.offsetWidth;
      const initialWidthR = sidebarRight.offsetWidth;
      const startX = event.clientX;

      const mouseMoveHandler = (e: MouseEvent) => {
        if (this.isResizing) {
          const offsetX = e.clientX - startX;
          const newWidthL = initialWidthL + offsetX;
          const newWidthR = initialWidthR - offsetX;

          if (newWidthL >= 0 && newWidthR >= 0) {
            sidebarLeft.style.width = newWidthL + 'px';
            sidebarRight.style.width = newWidthR + 'px';
          }
        }
      };

      const mouseUpHandler = () => {
        this.isResizing = false;
        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);
      };

      document.addEventListener('mousemove', mouseMoveHandler);
      document.addEventListener('mouseup', mouseUpHandler);
    }
  }

  startResizing(event: MouseEvent) {
    this.isResizing = true;
    const sidebarTop = document.getElementById('resizable-sidebar-top');
    const sidebarBottom = document.getElementById('resizable-sidebar-bottom');

    if (sidebarTop && sidebarBottom) {
      const initialHeightT = sidebarTop.offsetHeight;
      const initialHeightB = sidebarBottom.offsetHeight;
      const startX = event.clientY;

      const mouseMoveHandler = (e: MouseEvent) => {
        if (this.isResizing) {
          const offsetX = e.clientY - startX;
          const newHeightT = initialHeightT + offsetX;
          const newHeightB = initialHeightB - offsetX;

          if (newHeightT >= 0 && newHeightB >= 0) {
            sidebarTop.style.height = newHeightT + 'px';
            sidebarBottom.style.height = newHeightB + 'px';
          }
        }
      };

      const mouseUpHandler = () => {
        this.isResizing = false;
        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);
      };

      document.addEventListener('mousemove', mouseMoveHandler);
      document.addEventListener('mouseup', mouseUpHandler);
    }
  }


  onClearCooperate() { }

  compareDriver(driver) {
    this.selectedDriverId = driver._id;
    this.getTripsEmit()
  }

  openPrefferedDriver(trip) {
    this.preferedTrip = trip;
    if (this.selectedDriverId) {
      this.getTripsEmit();
    }
    this.getNearbyDriver(trip);

  }

  closePrefferedDriver() {
    // const sidebarRight = document.getElementById('horizontal-sidebar-right');
    const sidebarLeft = document.getElementById('horizontal-sidebar-left');
    sidebarLeft.style.width = '100%';
    // sidebarRight.style.width = '10%';
    this.removePreferredTrip() ;
    this.getTripsEmit();
  }

  getNearbyDriver(trip) {
    let data: any = {}
    // if (this.componentType !== 'Multiple Assign') {
    data = {
      jobOriginLatitude: trip.jobOriginLatitude,
      jobOriginLongitude: trip.jobOriginLongitude,
      fundingSource: trip.cooperate,
      spaceType: trip.spaceType,
      scheduleTime: trip.scheduleTime,
      isNearBy: true,
      loadTime: this.preSpaceTypes[trip.spaceType].loadTime,
      unloadTime: this.preSpaceTypes[trip.spaceType].unloadTime,
      milage: trip.milage,
      jobDestinationLatitude: trip.jobDestinationLatitude,
      jobDestinationLongitude: trip.jobDestinationLongitude,
      appointmentTime: trip.appointmentTime,
      isGoogleMiles: this.isGoogleMiles

    };

    if (trip.serviceArea) {
      data.serviceArea = trip.serviceArea
    }
    // }


    this._getNearbyDrivers.emit(data);
  }

  getNearbyDriversRes(apiResponse) {
    this.nearbyDrivers = apiResponse.drivers;
  }

  timeValidation(trip) {
    const params = {
      trip,
      violations: this.violations,
      timeZone: this.timeZone
    }
    return this.assignTripService.timeValidation(params);
  }

  setAllDriverServicesAreas() {
    for (let driverServiceArea of this.driverServiceAreas) {
      this.selectedServiceAreas.push(driverServiceArea._id);
    }
  }

  checkDriverFleetSpacetype(trip) {
    let isExist = false;
    if (trip.spaceType && this.selectedDriverId && this.preDriver[this.selectedDriverId].fleet && this.preDriver[this.selectedDriverId].fleet.capacities && this.preDriver[this.selectedDriverId].fleet.capacities.length) {
      isExist = this.preDriver[this.selectedDriverId].fleet.capacities.some(capacity => capacity.spaceType === trip.spaceType);
    }
    return isExist;
  }

  dropTrip(trip) {
    sweetAlert(
      "Alert",
      "Are you sure you want to drop this trip?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        let params = {
          assignId: trip._id,
          changeReason: "Will Do Later",
          driverId: this.selectedDriverId,
          company: { _id: this.user._id, displayName: this.user.displayName },
        };
        this.socketService.emit(Events.DROP_TRIP, params);
      }
    });
  }

  listenSocket() {
    this.socketService
      .addListener(Events.DROP_TRIP)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data.success) {
          this.getTripsEmit();
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });
  }

  getMiles(trip) {
    this.selectedTripETA = trip;
    if (!trip.jobOriginAddress || !trip.jobDestinationAddress) {
      sweetAlert('Alert', 'Please select Pickup & Drop Off address', 'warning', 'OK')
      return;
    }
    this.setUpSocketListener();
    let data = {
      origin: trip.jobOriginLatitude + ',' + trip.jobOriginLongitude,
      destination: trip.jobDestinationLatitude + ',' + trip.jobDestinationLongitude
    };
    this.socketService.emit(Events.GET_MILES_CALL, data);
  }

  setUpSocketListener() {
    this.socketService.addListener(Events.GET_MILES_CALL)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        this.selectedTripETA.googleMilage = data.message;
        this.socketService.removeListener(Events.GET_MILES_CALL);
      });
  }

  getDriverAddress(driver) {
    if (driver && driver.latitude && driver.longitude) {
      this.getAddress(driver, driver.latitude, driver.longitude);
    }
  }

  getAddress(driver, latitude, longitude) {
    this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
      if (status === 'OK') {
        if (results) {
          driver.currentAddress = results[0].formatted_address;
        } else {
          sweetAlert('Alert', 'No Address Found', 'warning', 'Ok')
        }
      } else {
        sweetAlert('Alert', `Geocoder failed due to: ${status}`, 'warning', 'Ok')
      }
    });
  }

  meterToMiles(distance) {
    return distance.toFixed(2);
    // return (distance / 1609).toFixed(2);
  }

  onChangeMilesSelector() {
    this.getTripsEmit();
  }

  onChangeDriver(evt) {
    this.selectedTimeLines = null;

    this.allTrips = [];
    this.nonSuggestedTrips = [];
    this.nonSuggestedMainTrips = [];
    this.driverTrips = [];
    this.tripsPickupPoints = [];
    this.driverMainTrips = [];
    this.waypoints = [];
    this.selectedTripsDriver = null;
    this.selectedDriverShiftOverrides = null;
    this.overrideShiftId = '';
    this.selectedDriverId = evt
    if (evt) {
      this.getCurrentDayDriverShift(evt);
    }
    this.getDriverTimelinesEmit()
  }

  stationManagerWiseDrivers() {
    this.selectedTimeLines = null;

    this.allTrips = [];
    this.nonSuggestedTrips = [];
    this.nonSuggestedMainTrips = [];
    this.driverTrips = [];
    this.tripsPickupPoints = [];
    this.driverMainTrips = [];
    this.waypoints = [];
    this.selectedTripsDriver = null;

    this.selectedDriverId = '';
    this.filteredDrivers = [];
    if (this.selectedStationManager && this.selectedStationManager.length) {
      for (let driver of this.drivers) {
        if (driver.stationManager && this.selectedStationManager.includes(driver.stationManager)) {
          this.filteredDrivers.push(driver);
        }
      }
    } else {
      this.filteredDrivers = this.drivers;
      this.isAllowDriversOnMap = false;
    }

  }


  getDriverTimelinesEmit() {
    if (!this.selectedDriverId) {
      this.getTripsEmit();
      return;
    }
    let queryString = {
      startDate: this.todayDate,
      driver: this.selectedDriverId
    };
    this._getDriverTimelines.emit(queryString);
  }

  getDriverTimelines(apiResponse) {
    this.selectedTimeLines = apiResponse;
    this.getTripsEmit();
  }

  driverBreak(breakObj?) {
    const driver = this.drivers.find(d => d._id === this.selectedDriverId);

    this.breakModalObj = {
      driver: driver,
      break: breakObj,
      date: this.todayDate
    };
  }

  driverBreakPayload(payload) {
    this._driverBreak.emit(payload);
  }

  onBreakModelClose() {
    this.breakModalObj = null;
    this.getTripsEmit();
  }

  getTripDisplayName(assign, first, last) {
    let textLable = '';
    if (assign.priorityClient && assign.priorityClient.displayName) {
      textLable = assign.priorityClient.displayName.toUpperCase();
      if (assign.isPickup) {
        if (assign.isBreakTrip) {
          textLable += " - Start."
        } else {
          textLable += " - Pickup Appt."
        }
      } else if (assign.isDropOff) {
        if (assign.isBreakTrip) {
          textLable += " - End."
        } else {
          textLable += " - Dropoff Appt."
        }
      }
    } else if (first) {
      textLable = "Pull - Out.";
    } else if (last) {
      textLable = "Shift - End.";
    }

    return textLable;
  }

  sortDrivers(column) {
    this.clearSorting(column);
    if (!this.columnsSortState[column]) {
      this.columnsSortState[column] = SORT_ORDER.DESC;
    } else {
      this.columnsSortState[column] = this.columnsSortState[column] === SORT_ORDER.DESC
        ? SORT_ORDER.ASC : SORT_ORDER.DESC
    }

    if (column === 'preDist') {
      this.nearbyDrivers.sort((a, b) => {
        return this.columnsSortState[column] === SORT_ORDER.DESC
          ? b.totalMiles - a.totalMiles
          : a.totalMiles - b.totalMiles
      });
    } else if (column === 'newDist') {
      this.nearbyDrivers.sort((a, b) => {
        return this.columnsSortState[column] === SORT_ORDER.DESC
          ? b.newMiles - a.newMiles
          : a.newMiles - b.newMiles
      });
    } else if (column === 'distDiff') {
      this.nearbyDrivers.sort((a, b) => {
        const aDistDiff = a.newMiles - a.totalMiles;
        const bDistDiff = b.newMiles - b.totalMiles;
        return this.columnsSortState[column] === SORT_ORDER.DESC ? bDistDiff - aDistDiff : aDistDiff - bDistDiff;
      });
    } else if (column === 'pickupDiff') {
      this.nearbyDrivers.sort((a, b) => {
        return this.columnsSortState[column] === SORT_ORDER.DESC
          ? b.puTimeDiff - a.puTimeDiff
          : a.puTimeDiff - b.puTimeDiff
      });
    } else if (column === 'dropoffDiff') {
      this.nearbyDrivers.sort((a, b) => {
        return this.columnsSortState[column] === SORT_ORDER.DESC
          ? b.doTimeDiff - a.doTimeDiff
          : a.doTimeDiff - b.doTimeDiff
      });
    }
  }

  clearSorting(columnToSort) {
    // do not clear the sorting state of the cloumn to be sorted
    this.columnsSortState
    Object.keys(this.columnsSortState).forEach(key => {
      if (key !== columnToSort) {
        this.columnsSortState[key] = '';
      }
    });
  }

  onEditTrip(trip,type) {
    const fundingSource = trip.cooperate ? this.preCooperates[trip.cooperate] : null;
    if (fundingSource && fundingSource.companyType === 'taxi') {
      this.editTaxiRideModalObj = trip
      this.editTaxiRideModalObj.isFromNonSuggested = type;
      return;
    }
    this.selectedEditTrip = trip;
    this.selectedEditTrip.isFromNonSuggested = type;
  }

  onEditTripUpdate(evt) {
    const selectedTrip = this.selectedEditTrip || this.editTaxiRideModalObj;
    if (selectedTrip && evt) {
      const scheduleTime = moment(selectedTrip.scheduleTime).tz(this.timeZone);
      const newScheduleTime = moment(evt.scheduleTime).tz(this.timeZone);
      const isSameDay = scheduleTime.isSame(newScheduleTime, 'day');
      if (selectedTrip.isFromNonSuggested) {
        const index = this.nonSuggestedTrips.findIndex(t => t._id === evt._id);
        if (isSameDay) {
          this.nonSuggestedTrips[index] = { ...this.nonSuggestedTrips[index], ...evt };
        } else {
          this.nonSuggestedTrips.splice(index, 1);
        }
        if (this.wrapper === 'planner') {
          this._onUpdateTrip.emit({ ...evt, isAssigned: false, isSameDay: isSameDay });
        }
      } else {
        const index = this.driverMainTrips.findIndex(t => t._id === evt._id);
        if (isSameDay) {
          this.driverMainTrips[index] = { ...this.driverMainTrips[index], ...evt }
        } else {
          this.driverMainTrips.splice(index, 1);
        }
        this.filterDriverMainTrips();
        if (this.wrapper === 'planner') {
          this._onUpdateTrip.emit({ ...evt, isAssigned: true, isSameDay: isSameDay });
        }
      }
      this.selectedEditTrip = null;
      this.editTaxiRideModalObj = null;
    }
  }
  isStringExist(substrings, str) {
    if (substrings.some((v) => str.toLowerCase().includes(v))) {
      return true;
    }
    return false;
  }

  setPartialEditModal(trip) {
    this.partialEditModalObj = trip;
  }

  updateTripNotes(evt) {

    const index = this.driverMainTrips.findIndex(t => t._id === evt._id);
    this.driverMainTrips[index] = { ...this.driverMainTrips[index], ...evt }
    this.filterDriverMainTrips();
    this.partialEditModalObj = null;
  }

  showActionButtons(idx) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }
  closeActionMenu(evt) {
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
  }

  //  // Remove Trip
  //  cancelTrip(trip) {
  //   this.cancelTripModalObj = trip;
  //  }

  //  async onCancelTrip(evt) {
  //    if (evt) {
  //     let findTripIndex = await this.nonSuggestedMainTrips.findIndex(t => t._id === evt._id);
  //      this.nonSuggestedMainTrips.splice(findTripIndex, 1);

  //      this.filterDriverMainTrips();
  //      this.filterNonSuggestedMainTrips();

  //   }
  //   this.cancelTripModalObj = null;
  // }

  getDriversShiftOverrides() {
    const payload = {
      startDate: moment.tz(this.todayDate, this.timeZone).startOf('day').toISOString(),
      endDate: moment.tz(this.todayDate, this.timeZone).endOf('day').toISOString(),
      status: 'active'
    }
    this.driverService
      .getShiftOverridesByDate(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data && data.length) {
          const avaliableShifts = data.filter(shift => !shift.isEnabled);
          if (avaliableShifts && avaliableShifts.length) {
            this.preDriversShiftOverrides = avaliableShifts.reduce((acc, override) => {
              const { driver, shift } = override;
              const { _id } = driver;
              if (shift) {
                if (!acc[_id]) {
                  acc[_id] = [];
                }
                acc[_id].push({ _id: override._id, ...shift, isDefault: false});
              }

              return acc;
            }, {});
            if (this.selectedDriverId) {
              this.getCurrentDayDriverShift(this.selectedDriverId)
            }
          }
        }
      });
  }

  onChangeDriverShift() {
    this.filterDriverMainTrips();
  }

  getCurrentDayDriverShift(driverId) {
    const currentDay = moment.tz(this.todayDate, this.timeZone).day();
    const driver = this.preDriver[driverId];
    const shift = driver.shifts.find(item => item.day === currentDay && item.isEnabled);
    if (this.preDriversShiftOverrides && this.preDriversShiftOverrides[driver._id]) {
      this.selectedDriverShiftOverrides = JSON.parse(JSON.stringify(this.preDriversShiftOverrides[driver._id]));
      if (shift && this.selectedDriverShiftOverrides && this.selectedDriverShiftOverrides.length) {
        this.overrideShiftId = shift._id;
        this.selectedDriverShiftOverrides.unshift({ ...shift, isDefault: true });
      }
    }
  }

  isTaxiRide(assign: any) {
    const fundingSource = assign.cooperate ? this.preCooperates[assign.cooperate] : null;
    return !!(fundingSource && fundingSource.companyType === 'taxi');
  }
}
